import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../Button";
import apiPlatform from "../../../apiPlatform";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import {toast} from "react-toastify";
import {isEmpty} from "lodash";
import {useTranslation} from "react-i18next";

const MergeVehicles = props => {
  const { t } = useTranslation('merge_vehicles');
  const [vehicleToMergeId, setVehicleToMergeId] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [merging, setMerging] = useState(false)

  useAfterUpdateEffect(() => {
    if(modalOpen){
      let searchParams = ''
      if(props.registrationNumberToMerge){
        searchParams = `registrationNumber=${props.registrationNumberToMerge}`
      }else if(props.vinToMerge){
        searchParams = `vin=${props.vinToMerge}`
      }else{
        toast.warn(t('vehicle_not_found'))
        setModalOpen(false)
        return
      }

      apiPlatform.vehicles.list(searchParams)
        .then(res => {
          if(!isEmpty(res.data['hydra:member'])){
            const vehicleToMerge = res.data['hydra:member'].find(v => v.id !== props.vehicleId)
            setVehicleToMergeId(vehicleToMerge.id)
          }else{
            toast.warn(t('vehicle_not_found'))
            setModalOpen(false)
          }
        })
    }
  }, [modalOpen])

  const merge = () => {
    setMerging(true)

    apiPlatform.vehicles.mergeVehicles({
      id: props.vehicleId,
      vehicleToMergeId,
    })
      .then(res => {
        toast.success(t('merge_success'))
        props.onMerged(res.data)
        setModalOpen(false)
      })
      .finally(() => setMerging(false))
  }

  return <React.Fragment>
    <span className="cursor-pointer" onClick={() => setModalOpen(true)}>{t('text')}</span>
    {modalOpen && <Modal isOpen size="md" toggle={() => setModalOpen(false)}>
      <ModalHeader toggle={() => setModalOpen(false)}>{t('modal_header')}</ModalHeader>
      <ModalBody>{t('modal_body_text')}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setModalOpen(false)}>{t('common:btn.cancel')}</Button>
        <Button onClick={merge} loading={merging} disabled={!vehicleToMergeId}>{t('btn_merge')}</Button>
      </ModalFooter>
    </Modal>}
  </React.Fragment>;
};

MergeVehicles.propTypes = {
  onMerged: PropTypes.func.isRequired,
  vehicleId: PropTypes.number.isRequired,
  registrationNumberToMerge: PropTypes.string,
  vinToMerge: PropTypes.string,
};

export default MergeVehicles;